let correlationId = 'AER-ADMIN'+Math.random().toString(36).substr(2, 9);

window.config = {
    version: process.env.VUE_APP_VERSION,
    build: process.env.VUE_APP_CI_BUILD,
    buildDate: process.env.VUE_APP_CI_BUILD_DATE,
    environment: process.env.VUE_APP_ENVIRONMENT,
    isLocal: (process.env.VUE_APP_ENVIRONMENT === 'local'),
    correlationId: correlationId,
    api: {
        authUri: process.env.VUE_APP_AUTH_URL,
        partsUri : process.env.VUE_APP_API_URL,
        errorsMessages: {
            '422' : 'Server Error: Please Try Again Later',
            '500' : 'Server Error: Please Try Again Later',
            '404' : 'Record not found',
            '401' : 'Session Expired. Please login back again.',
            '403' : 'Current logged user does not have rights for this action',
            generic : 'Server Error: Please Try Again Later'
        }
    },
    sentry : {
        url: process.env.VUE_APP_SENTRY_URL,
        attachProps: true
    },
    userSettings : { },


};
window.setUserSettings = function(key, value){
    window.config.userSettings[key] = value;
};

window.getUserSettings = function(key){
    return window.config.userSettings[key];
};
